import React, { lazy } from 'react'
import Loadable from '../../components/Loadable/Loadable';
import ClubTransactions from '../settings/Account-Settings/Transactions';

const DocumentsAwaitApproval = Loadable(lazy(() => import('./documents/DocumentsAwaitApproval')));
const AddWallet = Loadable(lazy(() => import("./wallet/AddWallet")));
const WalletList = Loadable(lazy(() => import("./wallet/WalletList")));
const CardForm = Loadable(lazy(() => import("./cards/CardForm")));
const CustomerList = Loadable(lazy(() => import("./customers/CustomerList")));
const CustomerForm = Loadable(lazy(() => import("./customers/customer-form/CustomerForm")));
const CustomerViewer = Loadable(lazy(() => import("./customers/customer-viewer/CustomerViewer")));
const ClientForm = Loadable(lazy(() => import("./clients/client-form/ClientForm")))
const ClientList = Loadable(lazy(() => import("./clients/ClientList")))
const ClientDetails = Loadable(lazy(() => import('./clients/client-viewer/ClientViewer')))
const CardList = Loadable(lazy(() => import("./cards/CardList")))
const AddMembershipType = Loadable(lazy(() => import("../pages/MembershipTypes/AddMemberShipType")))
const WalletConfiguration = Loadable(lazy(() => import("./wallet/WalletConfiguration")));
const CustomerAwaitingList = Loadable(lazy(() => import("./customers/CustomerAwaitingList")));
const CustomerAwaitingPhoto = Loadable(lazy(() => import('./customers/CustomerAwaitingPhoto')));
const ApprovedCustomer = Loadable(lazy(() => import('./customers/ApprovedCustomerList')))
const SendInvitation = Loadable(lazy(() => import('./events/SendInvitation')))
const NoticeBoard = Loadable(lazy(() => import('./notice-board/index')))
const LoginAsClient = Loadable(lazy(() => import('../sessions/login/LoginAsClient')))
const NewPlans = Loadable(lazy(() => import('./plans/NewPlans')))
const MembershipPlans = Loadable(lazy(() => import('./plans/MembershipPlans')))
const BulkImport = Loadable(lazy(() => import('./clients/BulkImport/BulkImport')))
const EmailAnalytics = Loadable(lazy(() => import('./email-analytics/EmailAnalytics')))



const pagesRoutes = [
    {
        path: "/pages/new-client/:id",
        element: <ClientForm />
    },
    {
        path: "/clients/bulk-import/:id",
        element: <BulkImport />
    },
    {
        path: "/pages/view-client/:id",
        element: <ClientDetails />
    },
    {
        path: "/pages/client-list",
        element: <ClientList />
    },
    {
        path: '/pages/card/:id',
        element: <CardForm />,
    },
    {
        path: '/pages/all-cards',
        element: <CardList />,
    },
    {
        path: '/pages/wallet-pass/:id',
        element: <AddWallet />,
    },
    {
        path: '/pages/all-wallet-pass',
        element: <WalletList />,
    },
    {
        path: '/pages/customer-list',
        element: <CustomerList condition='all' />,
    },
    {
        path: '/pages/await-approval',
        element: <CustomerAwaitingList condition='pending' />
    },
    {
        path: '/pages/approved-customer',
        element: <ApprovedCustomer condition='current' />
    },
    {
        path: '/pages/await-photo',
        element: <CustomerAwaitingPhoto condition='waiting' />
    },
    {
        path: '/pages/new-customer/:id',
        element: <CustomerForm />,
    },
    {
        path: '/pages/view-customer/:id',
        element: <CustomerViewer />,
    },
    {
        path: "/pages/membership-type/:id",
        element: <AddMembershipType />
    },
    {
        path: "/pages/wallet-pass/configure/:id",
        element: <WalletConfiguration />
    },
    {
        path: '/pages/events/invitation/:id',
        element: <SendInvitation />
    },
    {
        path: '/pages/notice-board',
        element: <NoticeBoard />
    },
    {
        path: "/pages/client-login/:id",
        element: <LoginAsClient />
    },
    {
        path: "/pages/membership-plans",
        element: <MembershipPlans />
    },
    {
        path: "/pages/membership-plans/:id",
        element: <NewPlans />
    },
    {
        path: "/pages/documents/await-approval",
        element: <DocumentsAwaitApproval />
    },
    {
        path: "/pages/email-analytics",
        element: <EmailAnalytics />
    },
    {
        path: "/pages/transactions",
        element: <ClubTransactions />
    }
]

export default pagesRoutes
